import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { AboutDialogComponent } from './about-dialog.component';

@NgModule({
  declarations: [AboutDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule],
  exports: [AboutDialogComponent],
  entryComponents: [AboutDialogComponent],
})
export class AboutDialogModule {}
